module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/thumb/brc-global-pl-36d794867dff9d6d6f0384d30749eeaf.jpg";